export function createUnhandledEntryError(unhandledValue) {
    return new Error("Unhandled value: " + unhandledValue);
}
//# sourceMappingURL=createUnhandledEntryError.js.map